/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DraftAIMessageDto } from '../models';
/**
 * RestDraftAIEmailApi - axios parameter creator
 */
export const RestDraftAIEmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAIEmail: async (userId: string, emailId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDraftAIEmail', 'userId', userId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('getDraftAIEmail', 'emailId', emailId)
            const localVarPath = `/api/users/{userId}/emails/{emailId}/draft-ai`
                .replace('{userId}', encodeURIComponent(String(userId)))
                .replace('{emailId}', encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestDraftAIEmailApi - functional programming interface
 */
export const RestDraftAIEmailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestDraftAIEmailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDraftAIEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftAIMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDraftAIEmail(userId, emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestDraftAIEmailApi.getDraftAIEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestDraftAIEmailApi - factory interface
 */
export const RestDraftAIEmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestDraftAIEmailApiFp(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} emailId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftAIEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftAIMessageDto> {
            return localVarFp.getDraftAIEmail(userId, emailId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestDraftAIEmailApi - interface
 */
export interface RestDraftAIEmailApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDraftAIEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftAIMessageDto>;

}

/**
 * RestDraftAIEmailApi - object-oriented interface
 */
export class RestDraftAIEmailApi extends BaseAPI implements RestDraftAIEmailApiInterface {
    /**
     * 
     * @param {string} userId 
     * @param {string} emailId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getDraftAIEmail(userId: string, emailId: string, options?: RawAxiosRequestConfig) {
        return RestDraftAIEmailApiFp(this.configuration).getDraftAIEmail(userId, emailId, options).then((request) => request(this.axios, this.basePath));
    }
}

